const ORG_TASK_SORT_ORDER = 10000;

export function catalogSortValue(task) {
  const order = Number(task?.sortOrder ?? task?.catalogSortOrder);
  return Number.isFinite(order) ? order : ORG_TASK_SORT_ORDER;
}

export function compareCatalogTasks(a, b) {
  const orderCmp = catalogSortValue(a) - catalogSortValue(b);
  if (orderCmp !== 0) return orderCmp;
  return (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' });
}

/** Unique category labels in catalog order (first appearance in a sortOrder-sorted list). */
export function uniqueCategoriesInSortOrder(tasks, emptyKey = null) {
  const seen = new Set();
  const list = [];
  let hasEmpty = false;
  const sorted = [...(tasks || [])].sort(compareCatalogTasks);
  sorted.forEach((task) => {
    const category = (task?.category || '').trim();
    if (!category) {
      hasEmpty = true;
      return;
    }
    if (!seen.has(category)) {
      seen.add(category);
      list.push(category);
    }
  });
  if (hasEmpty && emptyKey) list.push(emptyKey);
  return list;
}

export function isCategoryLevelTask(task) {
  return Boolean(task?.isCategoryLevel);
}

export function formatDailyWorkTaskLabel(task, unspecifiedHint) {
  if (!task) return '';
  if (isCategoryLevelTask(task)) {
    const category = (task.category || task.name || '').trim();
    return unspecifiedHint ? `${category} (${unspecifiedHint})` : category;
  }
  return task.name || '';
}
